import Vue from 'vue'
window._ = require("lodash");
window.moment = require("moment");
window.Promise = require("promise");

/* Define Moment locales */
window.moment.defineLocale("en-short", {
  parentLocale: "en",
  relativeTime: {
    future: "in %s",
    past: "%s",
    s: "1s",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "1 month ago",
    MM: "%d months ago",
    y: "1y",
    yy: "%dy"
  }
});

window.moment.locale("ro");

Vue.prototype._ = window._
Vue.prototype.$moment = window.moment
